var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRename(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Interface-Essential / Form-Edition / pencil-write-3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Interface-Essential-/-Form-Edition-/-pencil-write-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "pencil-write-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.712,16.386 L9,16.916 L9.53,13.2 L19.076,3.654 C19.6451241,3.08559043 20.4742593,2.86398241 21.2510785,3.07265354 C22.0278977,3.28132468 22.6343834,3.88857286 22.8420785,4.66565356 C23.0497736,5.44273427 22.8271241,6.27159045 22.258,6.84 L12.712,16.386 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25,15 L2.25,15 C1.42157288,15 0.75,15.6715729 0.75,16.5 L0.75,19.5 C0.75,20.3284271 1.42157288,21 2.25,21 L21.75,21 C22.5784271,21 23.25,20.3284271 23.25,19.5 L23.25,16.5 C23.25,15.6715729 22.5784271,15 21.75,15 L18.75,15",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRename);
export default __webpack_public_path__ + "static/media/rename.eb701fc5e553d1ca00156cf5977b70a1.svg";
export { ForwardRef as ReactComponent };